"use strict";
exports.__esModule = true;
exports.msgType = exports.denom = exports.GAS_LIMIT = void 0;
exports.GAS_LIMIT = '200000';
// TODO refactor to shared
// export enum pubKeyType {
//     secp256k1 = 'tendermint/PubKeySecp256k1',
// }
var denom;
(function (denom) {
    denom["uatom"] = "uatom";
    // stake = 'stake',
})(denom = exports.denom || (exports.denom = {}));
var msgType;
(function (msgType) {
    msgType["send"] = "cosmos-sdk/MsgSend";
    msgType["delegate"] = "cosmos-sdk/MsgDelegate";
})(msgType = exports.msgType || (exports.msgType = {}));
